// directives/permission.js
import store from '../store' // 这里用你的Vuex路径

export default {
  inserted(el, binding) {
    const { value } = binding
    const permissions = store.state.userStore.permissions || []
    
    if (value && value instanceof Array && value.length > 0) {
      const hasPermission = permissions.some(p => value.includes(p))

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      console.error("使用方式: v-hasPermi=\"['system:user:add']\"")
    }
  }
}
